<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <base-text-field v-model="query" ref="searchInput" class="tw-flex-grow" placeholder="Search for a program" size="sm" tabindex="1">
        <template #prefix>
          <search-icon class="tw-h-5 tw-w-5" />
        </template>
      </base-text-field>
      <base-button class="tw-ml-5 tw-hidden sm:tw-flex" type="primary" @click="editMsrp">
        <template v-slot:icon>
          <edit-icon />
        </template>
        Edit MSRP
      </base-button>
      <base-icon @click="editMsrp" class="tw-ml-3 tw-inline sm:tw-hidden">
        <edit-icon color="green" class="tw-h-5 tw-w-5" />
      </base-icon>
    </div>
    <base-table :loading="isLoading" :fields="fields" :items="groupedItems" class="tw-mt-5">
      <template #program="{item: program}">
        <div class="tw-whitespace-nowrap">{{ program.name }}</div>
      </template>
      <template #msrp="{item: program}">
        <div>{{ formatPrice(program.msrp) }}</div>
      </template>
      <template #empty-state>
        <div class="tw-flex tw-justify-center tw-py-5">
          No Results
        </div>
      </template>
      <template #loading-row>
        <td class="tw-py-3 tw-px-4">
          <div class="tw-flex tw-flex-col tw-w-full">
            <base-skeleton-loader class="tw-h-4 tw-w-full tw-mb-2" />
          </div>
        </td>
        <td class="tw-py-3 tw-px-4" align="right">
          <base-skeleton-loader class="tw-h-4 tw-w-20 tw-mb-2" />
        </td>
      </template>
    </base-table>
    <base-pagination v-model="page" class="tw-mt-2" />
    <business-program-msrp-slideover ref="msrpSlideover" :businessId="businessId" @save="loadPage" />
  </div>
</template>

<script>
import BusinessProgramMsrpSlideover from "@/views/business/business-programs-msrp/components/BusinessProgramMsrpSlideover";
import { EditIcon, SearchIcon } from "@/assets/svgs";
import { debounce } from "debounce";
import { orderBy } from "lodash";

const TAKE_KEY = "predictile_business_programs_take";

export default {
  components: {
    BusinessProgramMsrpSlideover,
    EditIcon,
    SearchIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      items: [],
      page: {
        take: localStorage.getItem(TAKE_KEY) ? +localStorage.getItem(TAKE_KEY) : 50,
        skip: 0,
        total: 0,
      },
      fields: [{ title: "Program", key: "program", thClass: "" }, { title: "MSRP", key: "msrp", thClass: "tw-w-0 xl:tw-whitespace-nowrap", align: "right" }],
      query: null,
      isLoading: false,
    };
  },
  computed: {
    groupedItems() {
      const grouped = {};
      this.items.forEach((item) => {
        if (!grouped[item.name]) {
          grouped[item.name] = {
            name: item.name,
            msrp: item.msrp || 0,
            programGroups: [],
          };
        }
        grouped[item.name].programGroups.push(item);
      });
      return Object.values(grouped);
    },
  },
  created() {
    this.loadPage();
    this.debouncedLoadPage = debounce(this.loadPage, 500);
  },
  mounted() {
    const searchInputRef = this.$refs.searchInput;
    searchInputRef.focus();
  },
  watch: {
    page(newValue) {
      localStorage.setItem(TAKE_KEY, newValue.take);
      this.loadPage();
    },
    query() {
      this.page.skip = 0;
      this.debouncedLoadPage();
    },
  },
  methods: {
    formatPrice(cents) {
      if (!cents) return "$0.00";
      return `$${(cents / 100).toFixed(2)}`;
    },
    editMsrp() {
      this.$refs.msrpSlideover.show();
    },
    loadPage() {
      this.isLoading = true;

      let url = `/businesses/${this.businessId}/programs/search`;
      url += `?skip=${this.page.skip}&take=${this.page.take}`;
      if (this.query) url += `&query=${encodeURIComponent(this.query)}`;

      this.$axios
        .get(url)
        .then((res) => {
          this.page.total = res.data.total;
          this.items = res.data.items;
          if (this.items.length !== 0) {
            this.items = orderBy(this.items, ["name", "programGroup"], ["asc", "asc"]);
          }
        })
        .catch((err) => {
          this.EventBus.$emit("GLOBAL_ERROR", {
            title: `Failed to load programs`,
            message: `We had a problem retrieving the list of programs. Please reload the page to try again.`,
            error: err,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
